interface ProductToolbarProps {
  resultCount: number;
  sortBy: string;
  onSortChange: (sort: string) => void;
  viewMode: 'grid' | 'list';
  onViewModeChange: (mode: 'grid' | 'list') => void;
}

const SORT_OPTIONS = [
  { value: 'newest', label: 'Newest' },
  { value: 'price-low-high', label: 'Price: Low to High' },
  { value: 'price-high-low', label: 'Price: High to Low' },
  { value: 'bestselling', label: 'Bestselling' },
];

export default function ProductToolbar({
  resultCount,
  sortBy,
  onSortChange,
  viewMode,
  onViewModeChange,
}: ProductToolbarProps) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-5 md:mb-6">
      {/* Result count */}
      <p className="text-xs md:text-sm font-label text-foreground-500">
        <strong className="text-foreground-800 font-semibold">{resultCount}</strong>{' '}
        product{resultCount !== 1 ? 's' : ''} found
      </p>

      {/* Sort + View toggle */}
      <div className="flex items-center gap-3">
        {/* Sort */}
        <div className="relative">
          <select
            value={sortBy}
            onChange={(e) => onSortChange(e.target.value)}
            className="appearance-none pl-3.5 pr-8 py-2 text-xs md:text-sm font-label border border-background-300 rounded-lg bg-background-50 text-foreground-700 focus:outline-none focus:border-accent-400 focus:ring-1 focus:ring-accent-400/30 cursor-pointer transition-colors"
          >
            {SORT_OPTIONS.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
          <div className="absolute right-2 top-1/2 -translate-y-1/2 pointer-events-none">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-down-s-line text-xs text-foreground-400"></i>
            </div>
          </div>
        </div>

        {/* View toggle */}
        <div className="flex items-center bg-background-100 rounded-lg p-1">
          <button
            onClick={() => onViewModeChange('grid')}
            className={`w-8 h-8 flex items-center justify-center rounded-md transition-all cursor-pointer ${
              viewMode === 'grid'
                ? 'bg-background-50 shadow-sm text-accent-500'
                : 'text-foreground-400 hover:text-foreground-600'
            }`}
            aria-label="Grid view"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-grid-line text-sm"></i>
            </div>
          </button>
          <button
            onClick={() => onViewModeChange('list')}
            className={`w-8 h-8 flex items-center justify-center rounded-md transition-all cursor-pointer ${
              viewMode === 'list'
                ? 'bg-background-50 shadow-sm text-accent-500'
                : 'text-foreground-400 hover:text-foreground-600'
            }`}
            aria-label="List view"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-list-view text-sm"></i>
            </div>
          </button>
        </div>
      </div>
    </div>
  );
}